import {ComponentFactoryResolver, Injectable, InjectionToken, Injector, Type} from '@angular/core';
import {ServiceName} from './Service';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../environments/environment';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';

@Injectable()
export class ResolverService {
  private static _instance: ResolverService;
  public static instance(): ResolverService {
    return this._instance;
  }

  get tranlateService(): TranslateService{
    return this._traslateService;
  }

  get spinnerService(): Ng4LoadingSpinnerService{
    return this._spinnerService;
  }

  constructor(private _spinnerService: Ng4LoadingSpinnerService, private resolver: ComponentFactoryResolver, private injector: Injector, private _traslateService: TranslateService) {
    this._traslateService.setDefaultLang(environment.defaultLang);
    this._traslateService.use(environment.defaultLang);
    ResolverService._instance = this;
  }

  getComponent(compName: string) {
    const factories = Array.from(this.resolver['_factories'].keys());
    const factoryClass: Type<any> = <Type<any>> factories.find((x: any) => x.name === compName);
    const factory = this.resolver.resolveComponentFactory( factoryClass );
    return factory.componentType;
  }

  getService(serviceName: string)  {
    return this.injector.get(ServiceName.get(serviceName));
  }

}



// WEBPACK FOOTER //
// ./src/app/core/services/resolver.service.ts